import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { ProductVariantService } from '../product-variant.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { UtilService } from 'app/core/services/util.service';

declare var jQuery: any;
declare var moment: any;

@Component({
  selector: 'itpx-product-variant-add',
  templateUrl: './product-variant-add.component.html',
  styleUrls: ['./product-variant-add.component.css']
})
export class ProductVariantAddComponent implements OnInit {

    private form: FormGroup;
    private isProceedDisabled: boolean;

    constructor(
        private service: ProductVariantService,
        private router: Router,
        private notificationService: NotificationService,
        private fb: FormBuilder,
        private utilService: UtilService
    ) { }

    ngOnInit() {
        this.buildForm();

        this.form.valueChanges.subscribe(
            change => {
                if(this.form.controls.name.valid && this.form.controls['product.id'].valid
                    && this.form.controls['language.id'].valid && this.form.controls.accountDeterminationGroup.valid
                    && this.form.controls['deliveryFormat.id'].valid) {
                    this.isProceedDisabled = false;
                } else {
                    this.isProceedDisabled = true;
                }
            }
        )
    }

    buildForm(): void {
        this.form = this.fb.group({
            // sku: [null, Validators.required],
            name: [null, Validators.required],
            shortDescription: [null, [Validators.required, Validators.maxLength(40)]],
            longDescription: [null],
            lastOrderDate: [null],
            endOfLife: [null],
            'product.id': [null, Validators.required],
            'language.id': [null, Validators.required],
            'deliveryFormat.id': [null, Validators.required],
            'certificateType.id': [null],
            'examFulfillmentType.id': [null],
            fulfillmentTurnAroundTime: [null],
            accountDeterminationGroup: [null, Validators.required],
            delivery: this.fb.group({
                freeReturn30Day: [null],
                requiresVoucher: [null],
                accessDuration: [null],
                'accessDurationType.id': [null],
                'freightClassId.id': [null, Validators.required],
                manualFulfillment: [false]
            })
        });
    }

    private onSaveFinished() {
        let form = this.form.value;
        let request = this.utilService.unflatten(form);
        request['delivery'] = this.utilService.unflatten(form.delivery);
        request['endOfLife'] = request['endOfLife'] ? (this.formatDateToUTC(request['endOfLife'])) : null;
        request['lastOrderDate'] = request['lastOrderDate'] ? (this.formatDateToUTC(request['lastOrderDate'])): null;

        if(request['renders'] && request['renders'].length > 0) {
            let obj = request['renders'][0];
            if(Object.getOwnPropertyNames(obj).length === null) {
                request['renders'] = [];
            }
        };
        this.service.add(request)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully created the product variant', 'Success');
                    this.router.navigate(['/agora/product-data/product-variants/']);
                }
            );
    }
    private onProceed() {
        jQuery('.nav-tabs a[href="#delivery"]').tab('show');
    }

    private formatDateToUTC(date) {
        let mDate = moment(date);
        return Date.parse(moment(mDate).utc().add(mDate.utcOffset(), 'm').format())/1000;
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-variants/add/product-variant-add.component.ts